import { Routes, Route, Navigate } from "react-router-dom";
import International from "./International";


const internationalRoutes = [
    {routeName: 'redbox' , component: <International/>},
    {routeName: 'expressflyer' , component: <International/>},
    {routeName: 'uspasswordrenewal' , component: <International/>},
    {routeName: 'studentexpress' , component: <International/>},
    {routeName: 'Visatronix' , component: <International/>},
    {routeName: 'internationalfreight' , component: <International/>},
    {routeName: 'custombrokrage' , component: <International/>},
    {routeName: 'regional-trucking' , component: <International/>},  
];

const InternationalRoutes = () => {
    return (
    <Routes>
       {internationalRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default InternationalRoutes;